export const BRIDGENESS_ADDRESS = {
  company: "Bridgeness Technologies Private Limited",
  lines: [
    "Wework Forum",
    "Infinity Tower C, DLF Cyber City, DLF Phase 3, Sec 25A",
    "Gurgaon, Haryana 122002",
    "India",
  ],
  gstin: "GSTIN 06AALCB5451C1ZX",
};

export function pickInvoiceId(...values) {
  for (let i = 0; i < values.length; i += 1) {
    const value = String(values[i] || "").trim();
    if (value) {
      return value;
    }
  }
  return "";
}

export function getApiErrorMessage(error, fallback) {
  const first = Array.isArray(error) ? error[0] : error;
  const candidates = [
    first?.m,
    first?.message,
    first?.error_message,
    error?.message,
  ];

  for (let i = 0; i < candidates.length; i += 1) {
    const value = candidates[i];
    if (typeof value === "string" && value.trim()) {
      return value;
    }
    if (value && typeof value === "object") {
      const nested = value.message || value.error_message || value.m;
      if (typeof nested === "string" && nested.trim()) {
        return nested;
      }
    }
  }

  if (Array.isArray(error)) {
    const joined = error
      .map((item) => item?.m || item?.message || item)
      .filter(Boolean)
      .join(", ");
    if (joined) {
      return joined;
    }
  }

  return fallback;
}

export function buildInvoiceDownloadFileName(assignmentName, fallbackId) {
  const raw = String(assignmentName || fallbackId || "payout")
    .trim()
    .replace(/[/\\?%*:|"<>]/g, "-")
    .replace(/\s+/g, " ")
    .replace(/\.+$/g, "")
    .slice(0, 80)
    .trim();
  return `${raw || "payout"}_invoice.pdf`;
}

export function downloadPdfBase64(pdfBase64, fileName) {
  const cleaned = String(pdfBase64 || "").replace(
    /^data:application\/pdf;base64,/,
    ""
  );
  if (!cleaned) {
    throw new Error("Invoice PDF data is missing.");
  }

  const binary = atob(cleaned);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: "application/pdf" });
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}

export function extractInvoiceNumberFromPayout(payout, response) {
  return pickInvoiceId(
    response?.invoice_number,
    response?.invoice_id,
    response?.payout_data?.invoice_number,
    response?.payout_data?.invoice_id,
    payout?.invoice_number,
    payout?.invoice_id
  );
}
